module.exports = __webpack_public_path__ + "img/man.a2a908b0.jpg";